export default "__VITE_ASSET__fb270952__"